import { render, staticRenderFns } from "./DoctorProfileComponent.vue?vue&type=template&id=9bcc258c&scoped=true"
import script from "./DoctorProfileComponent.vue?vue&type=script&lang=js"
export * from "./DoctorProfileComponent.vue?vue&type=script&lang=js"
import style0 from "./DoctorProfileComponent.vue?vue&type=style&index=0&id=9bcc258c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcc258c",
  null
  
)

export default component.exports